import { getLoadStartTime as getLoadStartTimeFromGlobal, setLoadStartTime as setLoadStartTimeToGlobal } from '../global-app-data/global-app-data';
import performance from '../performance/performance';

var Times = /*#__PURE__*/function () {
  function Times(appName) {
    this.appName = appName;
    this.apps = {};
    this.apps[appName] = {};
  }

  var _proto = Times.prototype;

  _proto._getKeyForApp = function _getKeyForApp(appId, widgetId) {
    if (appId === void 0) {
      appId = this.appName;
    }

    return widgetId ? appId + "_" + widgetId : appId;
  };

  _proto.setLoadStarted = function setLoadStarted(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        appId = _ref.appId,
        widgetId = _ref.widgetId;

    var key = this._getKeyForApp(appId, widgetId);

    if (!this.apps[key]) {
      this.apps[key] = {};
    }

    var loadStartTime = performance.now();
    this.apps[key].startLoadTime = loadStartTime;

    if (!appId) {
      setLoadStartTimeToGlobal(key, loadStartTime);
    }
  };

  _proto.getLoadStartTime = function getLoadStartTime(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;

    var key = this._getKeyForApp(appId, widgetId);

    var loadStartTime = this.getLoadStartTimeFromInstance(key) || getLoadStartTimeFromGlobal(key) || 0;
    return Math.floor(loadStartTime);
  };

  _proto.getLoadStartTimeFromInstance = function getLoadStartTimeFromInstance(key) {
    return this.apps[key] && this.apps[key].startLoadTime;
  };

  _proto.getAppLoadTime = function getAppLoadTime(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    return Math.floor(performance.now() - this.getLoadStartTime({
      appId: appId,
      widgetId: widgetId
    }));
  };

  _proto.getFirstRequestDuration = function getFirstRequestDuration(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId;

    return this.getLoadStartTime({
      appId: appId,
      widgetId: widgetId
    });
  };

  return Times;
}();

export { Times as default };